const SDK_VERSION = '7.105.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
